import { useEffect } from "react";
import { FeedbackHost } from "@/components/FeedbackHost";
import { dismissTopLayer } from "@/ui/layers";

export function UIInfrastructure() {
  useEffect(() => {
    const escape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && dismissTopLayer()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    document.addEventListener("keydown", escape, true);
    return () => document.removeEventListener("keydown", escape, true);
  }, []);
  return <FeedbackHost />;
}
